define.alias("shared/utils/formatters/ig-user-from-graph", "calendar/utils/formatters/ig-user-from-graph");